import { createFileRoute } from '@tanstack/react-router';

import { ProtectedRouteGuard } from '~/auth';

export const Route = createFileRoute('/_protected')({
  component: ProtectedRouteGuard,
});
